/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown>, total: NonNullable<unknown>, from: NonNullable<unknown>, to: NonNullable<unknown> }} Contributions_SummaryInputs */

const en_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} days tracked, ${i?.total} contributions between ${i?.from} and ${i?.to}.`)
};

const ar_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} يومًا متتبعًا، ${i?.total} مساهمة بين ${i?.from} و${i?.to}.`)
};

const bn_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} থেকে ${i?.to} পর্যন্ত ${i?.days} দিনের হিসাব: মোট ${i?.total}টি কন্ট্রিবিউশন।`)
};

const de_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} Tage erfasst, ${i?.total} Beiträge zwischen ${i?.from} und ${i?.to}.`)
};

const es_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} días registrados, ${i?.total} contribuciones entre ${i?.from} y ${i?.to}.`)
};

const fr_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} jours suivis, ${i?.total} contributions entre ${i?.from} et ${i?.to}.`)
};

const pt_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} dias registados, ${i?.total} contribuições entre ${i?.from} e ${i?.to}.`)
};

const zh_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已追踪 ${i?.days} 天，${i?.from} 至 ${i?.to} 期间共 ${i?.total} 次贡献。`)
};

const tr_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} gün izlendi, ${i?.from} ile ${i?.to} arasında ${i?.total} katkı.`)
};

const ru_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отслежено ${i?.days} дней, ${i?.total} коммитов между ${i?.from} и ${i?.to}.`)
};

const pl_contributions_summary = /** @type {(inputs: Contributions_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prześledzone ${i?.days} dni, ${i?.total} commitów między ${i?.from} a ${i?.to}.`)
};

/**
* | output |
* | --- |
* | "{days} days tracked, {total} contributions between {from} and {to}." |
*
* @param {Contributions_SummaryInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const contributions_summary = /** @type {((inputs: Contributions_SummaryInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contributions_SummaryInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_contributions_summary(inputs)
	if (locale === "bn") return bn_contributions_summary(inputs)
	if (locale === "de") return de_contributions_summary(inputs)
	if (locale === "es") return es_contributions_summary(inputs)
	if (locale === "fr") return fr_contributions_summary(inputs)
	if (locale === "pt") return pt_contributions_summary(inputs)
	if (locale === "zh") return zh_contributions_summary(inputs)
	if (locale === "tr") return tr_contributions_summary(inputs)
	if (locale === "ru") return ru_contributions_summary(inputs)
	if (locale === "pl") return pl_contributions_summary(inputs)
	return en_contributions_summary(inputs)
});